import { find } from 'lodash/fp';

export const Permission = {
  EditOnly: 'edit_only',
  EditAndViewActivity: 'edit_and_view_activity',
};

const hasPermission = permission => owner =>
  owner.ownerships && find({ permission }, owner.ownerships);

export const canEditOnly = hasPermission(Permission.EditOnly);

export const canEditAndViewActivity = hasPermission(
  Permission.EditAndViewActivity,
);
